import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Award, TrendingUp, Users } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const iconMap = {
  Shield: Shield,
  Award: Award,
  TrendingUp: TrendingUp,
  Users: Users
};

const ValuesSection = () => {
  const { t, isRTL } = useLanguage();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: 'easeOut' }
    }
  };

  return (
    <section className="py-20 bg-white" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"
        >
          {t.values.map((value) => {
            const IconComponent = iconMap[value.icon];
            return (
              <motion.div
                key={value.id}
                variants={itemVariants}
                className="group text-center"
              >
                <div className="relative mb-6">
                  <div className="w-20 h-20 mx-auto bg-[#9B4B8C]/10 rounded-2xl flex items-center justify-center group-hover:bg-[#9B4B8C] transition-colors duration-300">
                    <IconComponent className="w-10 h-10 text-[#9B4B8C] group-hover:text-white transition-colors duration-300" />
                  </div>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-3 tracking-wide">
                  {value.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {value.description}
                </p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default ValuesSection;
